// Centralised content + asset URLs for the AceMax Consulting site
export const ASSETS = {
  logoBadge:
    "https://customer-assets.emergentagent.com/job_e6792ff7-0a75-40be-9e3c-b6e1c4b95b2d/artifacts/0ak05xaf_ChatGPT%20Image%20Feb%202%2C%202026%20at%2010_46_27%20PM.png",
  logoFull:
    "https://customer-assets.emergentagent.com/job_e6792ff7-0a75-40be-9e3c-b6e1c4b95b2d/artifacts/gmdflu2g_ChatGPT%20Image%20Feb%2027%2C%202026%20at%2005_56_37%20PM.png",
  heroBg:
    "https://images.unsplash.com/photo-1767410913219-2db49c0575be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxwcmVzdGlnaW91cyUyMHVuaXZlcnNpdHklMjBjYW1wdXMlMjBpdnklMjBsZWFndWV8ZW58MHx8fHwxNzc4MTU1MjkyfDA&ixlib=rb-4.1.0&q=85",
  whoWeAreBg:
    "https://images.unsplash.com/photo-1746937116116-262a513f0d0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBib2FyZGluZyUyMHNjaG9vbCUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3NzgxNTUyOTJ8MA&ixlib=rb-4.1.0&q=85",
  tennis: {
    hero: "https://images.unsplash.com/photo-1714841197683-9bb219f6dca5?auto=format&fit=crop&w=1600&q=80",
    serve: "https://images.unsplash.com/photo-1714840961998-8d6c02ace00b?auto=format&fit=crop&w=1200&q=80",
    basketball: "https://images.unsplash.com/photo-1521055170349-25f955971658?auto=format&fit=crop&w=1200&q=80",
  },
  team: {
    garvita:
      "https://customer-assets.emergentagent.com/job_acemax-demo/artifacts/rpshz7c5_IMG_5180.jpg",
    grisham:
      "/grisham.jpg",
  },
};

export const NAV_LINKS = [
  { href: "#about", label: "About" },
  { href: "#team", label: "Team" },
  { href: "#services", label: "Services" },
  { href: "#tennis", label: "Athletics" },
  { href: "#why", label: "Why AceMax" },
  { href: "#stories", label: "Stories" },
  { href: "#contact", label: "Contact" },
];

export const SERVICES = [
  {
    title: "Education Counselling",
    desc: "Personalized plans, expert advice, and ongoing support through every step of the admissions journey for top universities worldwide.",
    icon: "GraduationCap",
  },
  {
    title: "Athletic Counselling",
    desc: "Turning sporting potential into scholarship offers. We decode what college coaches look for and build athletes who deliver it, on and off the court.",
    icon: "Trophy",
  },
  {
    title: "Boarding School Counselling",
    desc: "Identifying the best-fit boarding schools worldwide, with tailored guidance from application strategy to settling in.",
    icon: "School",
  },
  {
    title: "Psychometric Testing",
    desc: "Going beyond grades. Using globally validated psychometric tools to uncover each student's unique aptitudes, personality, and passions to map their ideal career path.",
    icon: "BrainCircuit",
  },
  {
    title: "Young Kids Advisory",
    desc: "Personalized, age-appropriate guidance that sets every child on the right path — academically, athletically, and personally — starting early.",
    icon: "Sparkles",
  },
];

export const DIFFERENTIATORS = [
  { title: "Ultra-Personalized", desc: "No cookie-cutter plans. Every student gets a strategy built around their unique strengths, goals, and story.", icon: "UserCog" },
  { title: "Global Network", desc: "Deep connections across top universities in the US, UK, Europe and beyond.", icon: "Globe2" },
  { title: "Data-Driven Strategy", desc: "Analytics expertise used to match students to programs where they'll truly thrive.", icon: "LineChart" },
  { title: "Athletic Edge", desc: "End-to-end support for student-athletes: from building a recruit profile to navigating scholarships, guided by a professional athlete.", icon: "Medal" },
  { title: "We Truly Care", desc: "Born from friendship and purpose, we invest in every family's success as if it were our own.", icon: "HeartHandshake" },
  { title: "Psychometric Insight", desc: "Scientific testing ensures students discover the path best suited to their personality and potential.", icon: "Compass" },
];

export const TEAM = [
  {
    name: "Garvita Dutta",
    role: "Co-Founder & Strategic Advisor",
    credentials: [
      "MS in Management, Georgetown University",
      "Double Major in Economics & Political Science, Lady Shri Ram College (Delhi University)",
      "Professional Tennis Player",
    ],
    bio: "Expert in athletic and academic development, helping student-athletes build profiles for top global universities.",
    image: ASSETS.team.garvita,
    objectPosition: "center 35%",
  },
  {
    name: "Grisham Sofat",
    role: "Co-Founder & Strategic Advisor",
    credentials: [
      "MSc Business Analytics, Imperial College London (ranked #2 in the world)",
      "B.Tech Mechanical Engineering, VNIT Nagpur",
      "Former Data Analyst at John Deere",
    ],
    bio: "Expert in profile positioning, admissions strategy, and data-driven university matching for US, UK, and Europe.",
    image: ASSETS.team.grisham,
    objectPosition: "center 72%",
  },
];

export const STORIES = [
  {
    name: "Arjun M.",
    profile: "Tennis Player → University of Illinois",
    subtext: "Athletic Scholarship",
    quote:
      "I had the rankings but had no idea how to reach out to college coaches. AceMax built my entire recruit profile, helped me craft emails, and within 6 months I had a full athletic scholarship offer. Garvita understood exactly what I was going through — she'd lived it herself.",
    rating: 5,
  },
  {
    name: "Priya S.",
    profile: "IB Student → LSE & Warwick",
    subtext: "Accepted Both",
    quote:
      "The process felt overwhelming until AceMax broke it down into a clear strategy. Grisham helped me position my profile in a way I'd never thought of — and I got into both my dream schools.",
    rating: 5,
  },
  {
    name: "Rohan K.",
    profile: "Class 8 → Top UK Boarding School",
    subtext: "First-Choice Admission",
    quote:
      "We started working with AceMax when our son was just 13. Their Young Kids Advisory helped us understand the boarding school landscape early and Rohan got into his first-choice school in England. Worth every moment.",
    rating: 5,
  },
];

export const AREAS_OF_INTEREST = [
  "Education Counselling",
  "Athletic Counselling",
  "Boarding School Counselling",
  "Psychometric Testing",
  "Young Kids Advisory",
  "Not Sure Yet",
];

export const CONTACT = {
  email: "info@acemaxconsulting.com",
  phones: ["+91 7087102998", "+91 7087882998"],
};
